import styled from 'styled-components';

export const EntryContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
`;

export const EntryContent = styled.div`
	display: flex;
	align-items: center;
	flex: 1;
	min-width: 0;
`;

export const ActionsSection = styled.div`
	display: flex;
	gap: 0px;
	align-items: center;
	margin-left: 8px;
`;

export const ActionButton = styled.button`
	background: transparent;
	border: none;
	padding: 2px;
	border-radius: 4px;
	width: 20px;
	height: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;

	&:hover {
		background: ${({ theme }) => theme.gray[200]};
	}
`;
